import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseLiveState = props => {
    const ans = '居住情形'
    const select_arr = [
        {
            value: '1',
            label: '與父親同住'
        },
        {
            value: '2',
            label: '與母親同住'
        },
        {
            value: '3',
            label: '與祖父同住'
        },
        {
            value: '4',
            label: '與祖母同住'
        },
        {
            value: '5',
            label: '與其他親戚同住'
        },
        {
            value: '6',
            label: '寄住友人家'
        },
        {
            value: '7',
            label: '獨居（含租房居住）'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_live_state_array"
                   />
        </div>
    )
}

export default SseLiveState


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseLiveState.jsx